export default __webpack_public_path__ + "static/media/giflogo.1940a851.GIF";